  (() => {
    const selector = 'digi-crm-progress';
    const cartRoutes = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

    const dispatchCartChange = () => {
      document.dispatchEvent(new CustomEvent('digi:cart-changed'));
    };

    if (!window.digiCrmProgressFetchPatched) {
      window.digiCrmProgressFetchPatched = true;
      const originalFetch = window.fetch;

      window.fetch = async (...args) => {
        const response = await originalFetch(...args);
        const requestUrl = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

        if (response.ok && cartRoutes.some((route) => requestUrl.includes(route))) {
          window.setTimeout(dispatchCartChange, 80);
        }

        return response;
      };
    }

    class DigiCrmProgress extends HTMLElement {
      connectedCallback() {
        this.triggerVariantIds = new Set(
          (this.dataset.triggerVariantIds || '')
            .split(',')
            .map((id) => Number(id.trim()))
            .filter(Boolean)
        );
        this.message = this.querySelector('[data-progress-message]');
        this.track = this.querySelector('[data-progress-track]');
        this.fill = this.querySelector('[data-progress-fill]');
        this.steps = Array.from(this.querySelectorAll('[data-progress-step]'));
        this.refresh = this.refresh.bind(this);
        this.queueRefresh = this.queueRefresh.bind(this);

        document.addEventListener('digi:cart-changed', this.queueRefresh);
        document.addEventListener('cart:updated', this.queueRefresh);
        document.addEventListener('cart:refresh', this.queueRefresh);
        document.addEventListener('discount:update', this.queueRefresh);

        this.cartCountObserver = new MutationObserver(this.queueRefresh);
        document.querySelectorAll('[data-cart-count]').forEach((counter) => {
          this.cartCountObserver.observe(counter, {
            childList: true,
            characterData: true,
            subtree: true
          });
        });

        this.refresh();
      }

      disconnectedCallback() {
        document.removeEventListener('digi:cart-changed', this.queueRefresh);
        document.removeEventListener('cart:updated', this.queueRefresh);
        document.removeEventListener('cart:refresh', this.queueRefresh);
        document.removeEventListener('discount:update', this.queueRefresh);
        this.cartCountObserver?.disconnect();
        window.clearTimeout(this.refreshTimer);
      }

      queueRefresh() {
        window.clearTimeout(this.refreshTimer);
        this.refreshTimer = window.setTimeout(this.refresh, 180);
      }

      async refresh() {
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart.js`, {
            headers: { Accept: 'application/json' }
          });

          if (!response.ok) return;
          this.render(await response.json());
        } catch (error) {
          console.error('Não foi possível atualizar o progresso da oferta.', error);
        }
      }

      render(cart) {
        const paidItems = (cart.items || []).filter((item) => item.original_line_price > 0);

        const triggerQuantity = paidItems.reduce((total, item) => {
          return total + (
            this.triggerVariantIds.has(Number(item.variant_id))
              ? item.quantity
              : 0
          );
        }, 0);

        const totalPaidQuantity = paidItems.reduce(
          (total, item) => total + item.quantity,
          0
        );

        const additionalItems = triggerQuantity > 0
          ? Math.min(2, Math.max(0, totalPaidQuantity - 1))
          : 0;

        const progress = triggerQuantity === 0
          ? 0
          : additionalItems === 0
            ? 28
            : additionalItems === 1
              ? 50
              : 100;

        this.fill.style.width = `${progress}%`;

        this.track.setAttribute(
          'aria-valuenow',
          String(additionalItems)
        );

        this.steps.forEach((step) => {
          const stepValue = Number(step.dataset.progressStep);

          const isActive =
            triggerQuantity > 0 &&
            stepValue <= additionalItems;

          step.classList.toggle('is-active', isActive);
        });

        if (triggerQuantity === 0) {
          this.message.textContent = this.dataset.emptyText;
          return;
        }

        if (additionalItems === 0) {
          this.message.textContent = this.dataset.triggerText;
          return;
        }

        if (additionalItems === 1) {
          this.message.textContent = this.dataset.firstText;
          return;
        }

        this.message.textContent = this.dataset.secondText;
      }
    }

    if (!customElements.get(selector)) {
      customElements.define(selector, DigiCrmProgress);
    }
  })();
